<template>
    <div>
        <v-text-field
            outlined
            v-model="innerValue"
            :rules="rules"
            :label="label"
        />
    </div>
</template>

<script>
    // import places from "places.js"

    export default {
        props: {
            rules: {
                type: [Object, Array, String],
                default: () => {
                    return [];
                },
            },
            label: {
                type: String,
                value: ''
            },
            value: {
                type: null
            },
            countryCode: String
        },
        name: "AddressAutoComplete",
        data() {
            return {
                modal: false,
                innerValue: null,
                addresses: [],
                addressLoading: false,
                searchSync: ''
            }
        },
        methods: {
            handleChange() {
                this.$emit('input', this.innerValue);
            },
            handleSomeChange(e) {
                console.log(e);
            },
            search(terms) {
                this.addressLoading = true;

                this.addressLoading = false;
            },
            addressMarked() {

            }
        },
        watch: {
            searchSync(new_value) {
                if (new_value)
                    this.search(new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            },
            innerValue(new_value) {
                this.$emit('input', new_value)
            }
        },
        created() {


        },
        mounted() {
            if (this.value){
                this.innerValue = this.value;
            }
        }
    }
</script>
